import { Injectable } from "@angular/core";

@Injectable({
  providedIn: 'root'
})
export class SessionStorageService {

  get<TKey, TValue>(key: TKey): TValue {
    const stringKey = this.trySerialise(key);
    const stringValue = this.tryGetItem(stringKey);
    const value = this.tryDeserialise<TValue>(stringValue);
    return value;
  }

  set<TKey, TValue>(key: TKey, value: TValue): void {
    if (value) {
      const stringKey = this.trySerialise(key);
      const stringValue = this.trySerialise(value)
      this.trySetItem(stringKey, stringValue);
    }
    else {
      const stringKey = this.trySerialise(key);
      this.tryRemoveItem(stringKey);
    }
  }

  private tryGetItem(key: string): string {
    try {
      return window.sessionStorage.getItem(key);
    }
    catch {
      return null;
    }
  }

  private trySetItem(key: string, value: string): void {
    try {
      window.sessionStorage.setItem(key, value);
    }
    catch {
    }
  }

  private tryRemoveItem(key: string): void {
    try {
      window.sessionStorage.removeItem(key);
    }
    catch {
    }
  }

  private tryDeserialise<T>(s: string): T {
    try {
      return JSON.parse(s) as T;
    }
    catch {
      return null;
    }
  }

  private trySerialise<T>(o: T): string {
    try {
      return JSON.stringify(o);
    }
    catch {
      return null;
    }
  }
}
